import { defineMessages } from 'react-intl'

export default defineMessages({
  dateRangeSelectOption: {
    id: 'SpaceAnalyticsPage.Section.dateRangeViewTitle.Title',
    defaultMessage: 'Date Range'
  },

  pastOneHourSelectOption: {
    id: 'SpaceAnalytics.Section.pastOneHourSelect.Option',
    defaultMessage: 'Last Hour'
  },

  pastTwentyFourHoursSelectOption: {
    id: 'SpaceAnalytics.Section.pastTwentyFourHoursSelect.Option',
    defaultMessage: 'Last 24 Hours'
  },

  pastSevenDaysSelectOption: {
    id: 'SpaceAnalytics.Section.pastSevenDaysSelect.Option',
    defaultMessage: 'Last 7 Days'
  },

  pastThirtyDaysSelectOption: {
    id: 'SpaceAnalytics.Section.pastThirtyDaysSelect.Option',
    defaultMessage: 'Last 30 Days'
  },

  pastNinetyDaysSelectOption: {
    id: 'SpaceAnalytics.Section.pastNinetyDaysSelect.Option',
    defaultMessage: 'Last 90 Days'
  },

  pastTwelveMonthsOption: {
    id: 'SpaceAnalytics.Section.pastTwelveMonths.Option',
    defaultMessage: 'Last 12 Months'
  },

  yearToDateOption: {
    id: 'SpaceAnalytics.Section.yearToDate.Option',
    defaultMessage: 'Year to Date'
  },

  allTimeOption: {
    id: 'SpaceAnalytics.Section.allTime.Option',
    defaultMessage: 'All Time'
  }
})
